import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#0A1128] text-white grain">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 pt-20 pb-10 relative">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_notes-to-site/artifacts/cver0rlc_HappyHomeAgency%20Logo2026.png"
              alt="Happy Home Agency"
              className="h-24 w-auto mb-6 bg-white p-2"
            />
            <div className="text-xs tracking-[0.28em] uppercase text-[#A1A9BC] mb-6">Making Homes Happy<br/>Since 2006 · Lic. 06C4290</div>
            <p className="text-sm text-[#A1A9BC] leading-relaxed">
              Singapore's trusted domestic helper matching agency. We don't just place helpers — we help build happy homes.
            </p>
          </div>

          <div>
            <div className="overline text-[#688A4E] mb-4">{t("footer.explore")}</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-[#688A4E] transition">{t("nav.about")}</Link></li>
              <li><Link to="/services" className="hover:text-[#688A4E] transition">{t("nav.services")}</Link></li>
              <li><a href="https://happyhome.netmaid.com.sg/searchmaid" target="_blank" rel="noreferrer" className="hover:text-[#688A4E] transition">{t("nav.searchMaid")}</a></li>
              <li><Link to="/application" className="hover:text-[#688A4E] transition">{t("nav.application")}</Link></li>
              <li><Link to="/blog" className="hover:text-[#688A4E] transition">{t("nav.blog")}</Link></li>
              <li><Link to="/resources" className="hover:text-[#688A4E] transition">{t("nav.resources")}</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline text-[#688A4E] mb-4">{t("footer.visitUs")}</div>
            <ul className="space-y-4 text-sm text-[#D5D8DF]">
              <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#688A4E]"/>
                <span>304 Orchard Road<br/>#04-07 Lucky Plaza<br/>Singapore 238863</span>
              </li>
              <li className="flex gap-3"><Clock className="w-4 h-4 mt-0.5 shrink-0 text-[#688A4E]"/>
                <span>Mon–Fri · 10am – 7pm<br/>Sat–Sun · 10am – 6pm<br/>PH · By Appointment</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="overline text-[#688A4E] mb-4">{t("footer.reachOut")}</div>
            <ul className="space-y-4 text-sm text-[#D5D8DF]">
              <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0 text-[#688A4E]"/>
                <a href="tel:+6591351039" className="hover:text-white transition">9135 1039</a>
              </li>
              <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0 text-[#688A4E]"/>
                <a href="mailto:happyhome_agency@yahoo.com.sg" className="hover:text-white transition break-all">happyhome_agency@yahoo.com.sg</a>
              </li>
            </ul>
            <div className="mt-6 pt-6 border-t border-white/10 text-xs text-[#A1A9BC]">
              Consultants: Carol · George<br/>
              EA Personnel: R1113494 · R1102140
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-[#A1A9BC]">© {new Date().getFullYear()} Happy Home Agency Pte Ltd · All rights reserved.</div>
          <div className="text-xs text-[#A1A9BC]">Happy Home Precision Match™ · Happy Home Matching Score™ · 365-Day Employer Care Program™</div>
        </div>

        <div className="pointer-events-none select-none absolute -bottom-8 left-0 right-0 text-center font-serif text-[18vw] leading-none text-white/[0.04]">
          happy home
        </div>
      </div>
    </footer>
  );
}
